<template>
  <v-dialog v-model="dialog" lazy width="854">
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>
          {{
            region._id
              ? $t('titles.global.updateModel', { field: $tc('models.region') })
              : $t('titles.global.newAModel', { field: $tc('models.region') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="region.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>

          <v-flex md6 xs12 px-2>
            <CountryField
              v-model="region.countryId"
              v-validate="'required'"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.country') })
              "
              autocomplete="new-text"
              browser-autocomplete
              :data-vv-name="$tc('models.country')"
              :error-messages="errors.collect($tc('models.country'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-switch
              v-model="region.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!region._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CountryField from '@/components/widgets/Input/CountryField'
import TranslationField from '@/components/widgets/Input/TranslationField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'RegionForm',
  components: {
    TranslationField,
    CountryField,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      region: {},
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) this.region = Object.assign({}, parseObject(val))
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.region = parseObject(this.selected)
  },
  computed: {
    ...mapState({
      selected: (state) => state.regions.selected,
      loading: (state) => state.regions.loading,
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'regions/create',
      setUpdate: 'regions/update',
      reset: 'regions/reset',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return

          let payload = Object.assign({}, this.region)
          if (!payload._id) {
            this.setCreate(payload).then(() => {
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then(() => {
              this.cancel()
            })
          }
        }
      )
    },
    cancel() {
      this.clear()
      this.$emit('close')
    },
    clear() {
      this.reset()
      this.$validator.reset()
    },
  },
}
</script>
